<div class="row rowColor">
<div class="col-md-4"></div>
<div class="col-md-5 headingCenter">
<h1 class="headingStyle">{{heading}}</h1>
</div>    
</div>  